// ...existing code...
import React from "react";
import "./Digital.css";
import { FaGlobe, FaCloud, FaNetworkWired, FaRobot, FaShieldAlt, FaChartLine, FaDigitalOcean } from "react-icons/fa";
import { HiOutlineLightBulb } from "react-icons/hi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { FaCircleCheck, FaGear } from "react-icons/fa6";

const SERVICES = [
  {
    icon: <FaGear />,
    title: "Search Engine Optimization (SEO)",
    text: "We optimize your website to secure top search engine rankings, ensuring your brand is the first thing your target customers see.",
  },
  {
    icon: <FaCircleCheck />,
    title: "Pay-Per-Click (PPC) Advertising",
    text: "We manage your paid advertising to deliver measurable results, maximizing your ROI with strategic, cost-effective ad placements.",
  },
  {
    icon: <FaNetworkWired />,
    title: "Social Media Marketing",
    text: "We manage your social media presence, creating engaging content and ad campaigns that drive user engagement and increase your reach.",
  },
 /* {
    icon: <FaChartLine />,
    title: "Data & Analytics",
    text: "Unlock business insights with real-time dashboards, data engineering, and AI-driven forecasting.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Cybersecurity & Compliance",
    text: "Protect critical assets with advanced threat detection, encryption, and governance frameworks.",
  },
  {
    icon: <HiOutlineLightBulb />,
    title: "Innovation Consulting",
    text: "Advisory on emerging tech adoption — from AI to blockchain — to accelerate digital transformation.",
  },  */
];

const WHY = [
  { icon: <FaChartLine />, title: "Proven Track Record", text: "With a history of proven results, our team helps businesses elevate their online visibility, attract qualified leads, and grow revenue using strategic SEO and marketing." },
  { icon: <FaDigitalOcean />, title: "Comprehensive Digital Solutions", text: "Our unified digital strategies encompass every key channel, from SEO and PPC to social media and email marketing, for a powerful, holistic approach to business growth." },
  { icon: <FaGlobe />, title: "Customized Campaigns", text: "Every campaign we create is a custom strategy, engineered to meet your specific business goals and guarantee exceptional impact and maximum return on your investment." },
];

const Digitalmarketing = () => {
  return (
    <div className="digital-container">
      <header className="digital-header">
        <div className="header-content">
          <h1>SEO & DIGITAL MARKETING</h1>
          <p className="subtitle">
           Unlock business insights with real-time dashboards, data engineering, and AI-driven forecasting.
          </p>

          <div className="header-ctas">
             <Link
          to="/contact" // ✅ Navigate to Contact page
          className="btn-primary"
          aria-label="Contact Lyros"
        >
          Talk to our Expert team
        </Link>
          </div>
        </div>

        <svg className="header-decor" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="gB" x1="0" x2="1">
              <stop offset="0" stopColor="#0ea5e9" stopOpacity="0.14" />
              <stop offset="1" stopColor="#6366f1" stopOpacity="0.06" />
            </linearGradient>
          </defs>
          <path d="M0 140 C160 40 360 240 800 80 L800 200 L0 200 Z" fill="url(#gB)"></path>
        </svg>
      </header>

      <main className="lyros-main">
        <section className="intro-section card reveal-up">
          <div className="intro-grid">
            <div>
              <h2>Driving Growth through Digital Marketing and SEO</h2>
              <p>
               Unlock your brand's potential and conquer the digital landscape. We craft personalized strategies that boost your visibility, attract qualified leads, and grow your revenue. Our team delivers impactful results by leveraging cutting-edge SEO, targeted social media campaigns, and compelling content that resonates with your audience. </p>
            </div>

            <div className="kpi-cards">
              <div className="kpi">
                <strong>60%</strong>
                <span>Seo cost optimization</span>
              </div>
              <div className="kpi">
                <strong>3X</strong>
                <span>Faster innovation cycles</span>
              </div>
              <div className="kpi">
                <strong>99.9%</strong>
                <span>Uptime reliability</span>
              </div>
            </div>
          </div>
        </section>

        <section className="services-section">
          <h3 className="section-title">Our Services</h3>
          <div className="services-grid">
            {SERVICES.map((s, i) => (
              <article className="service-card reveal-up" key={i}>
                <div className="service-icon">{s.icon}</div>
                <div className="service-body">
                  <h4>{s.title}</h4>
                  <p>{s.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="examples-section">
          <h3 className="section-title">Case Studies</h3>
          <div className="examples-grid">
            <article className="example-card reveal-up">
              <h4>Data-Driven Strategy</h4>
              <p>
We transform raw data into powerful, customized strategies. Our analysis reveals your audience's behavior, allowing us to build a digital marketing plan that directly supports your business goals.
</p>
            </article>
            <article className="example-card reveal-up">
              <h4>On-Page and Off-Page SEO</h4>
              <p>
We build a comprehensive SEO foundation, from on-page optimization like keyword research and content creation to off-page strategies like backlinks, to boost your rankings.
</p>
            </article>
            <article className="example-card reveal-up">
              <h4>Continuous Optimization</h4>
              <p>
We actively manage and refine your campaigns for sustained success, continuously adjusting our strategy based on real-time data and market trends to ensure ongoing performance.
</p>
            </article>
          </div>
        </section>

        <section className="why-section">
          <h3 className="section-title">Why choose us</h3>
          <div className="why-grid">
            {WHY.map((w, i) => (
              <div className="why-card reveal-up" key={i}>
                <div className="why-icon">{w.icon}</div>
                <div>
                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section reveal-up">
          <div className="cta-card">
            <div>
              <h3>Let’s build your digital future together</h3>
              <p>Partner with Digital Marketing to accelerate innovation and scale your business securely.</p>
            </div>
            <div className="cta-actions">
             <Link
                       to="/contact" // ✅ Navigate to Contact page
                       className="btn-primary"
                       aria-label="Contact Lyros"
                     >
                      Get Started
                     </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Digitalmarketing;
